type ValidationErrors = Record<string, unknown>;

const collectMessages = (value: unknown): string[] => {
  if (typeof value === 'string') {
    return value.trim() ? [value.trim()] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(collectMessages);
  }

  if (value && typeof value === 'object') {
    return Object.values(value as ValidationErrors).flatMap(collectMessages);
  }

  return [];
};

export const getValidationMessage = (data: unknown): string | null => {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const messages = collectMessages((data as { errors?: unknown }).errors);
  const uniqueMessages = Array.from(new Set(messages));

  return uniqueMessages.length > 0 ? uniqueMessages.join('\n') : null;
};

export const getApiErrorMessage = (
  error: any,
  fallback = 'Não foi possível processar a solicitação. Tente novamente.'
): string => {
  const data = error?.response?.data;

  return getValidationMessage(data)
    || (typeof data?.message === 'string' && data.message)
    || (typeof error?.message === 'string' && error.message)
    || fallback;
};
